import React, {useEffect, useState} from 'react';
import {css} from 'glamor';
import {Button} from './Button';
import {Container, StartContainer} from './Container';
import {H2} from './Typography';
import {Loading, LoadingError} from './LoadingFork';
import {LogoBox} from './LogoBox';
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import {makeStyles} from "@material-ui/core/styles";
import authManager from "../lib/authManager";
import {Redirect} from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import api from '../lib/api';

const useStyles = makeStyles(() => ({
    card: {
        width: '600px',
        height: '530px',
        borderRadius: '25px',
        background: 'linear-gradient(#B0FF33, #97C93B)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 6px 10px rgba(0,0,0,.08), 0 0 6px rgba(0,0,0,.05)',
        transition: '.3s transform cubic-bezier(.155,1.105,.295,1.12),.3s box-shadow,.3s -webkit-transform cubic-bezier(.155,1.105,.295,1.12)',
    },
    nestedCard: {
        // overflowY: 'auto',
        width: '571px',
        height: '501px',
        borderRadius: '25px',
        background: '#fff',
    },
    cardContent: {
        alignItems: 'center'
    },
    signInButton: {
        backgroundColor: '#3127B8',
        marginTop: '35px',
        height: '40px',
        width: '48%',
        fontSize: '18px'
    }
}))

export function InstallationSelector({ history }) {
    if (!authManager.isAuthenticated) return <Redirect to="/login" />;

    const [selectedInstallation, setSelectedInstallation] = useState(null);
    const classes = useStyles();
    const [installations, setInstallations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect( () => {
        const fetchInstallations = async () => {
            try {
                setLoading(true);
                const { data } = await api.installations();
                setInstallations(data.installations || []);
            } catch (e) {
                setError(e.message);
            } finally {
                setLoading(false);
            }
        };

        fetchInstallations();
    }, []);

    // Installation selector makes no sense for users with 1 role
    const currentUser = authManager.currentUser;
    const userRoles = currentUser.userRoles || [];

    if (!currentUser.isRootAdmin && userRoles.length === 1 && installations.length > 0) {
        const installationId = userRoles[0].installationId;
        const installation = installations.find((i) => i.id === installationId);

        if (installation) {
            return <Redirect to={authManager.landingPathFor(installation)} />;
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        if (!selectedInstallation) return;

        history.push(authManager.landingPathFor(selectedInstallation));
    }

    if (loading) return <Loading/>
    if (error) return <LoadingError error={error}/>

    return (
        <StartContainer>
            <Card className={classes.card}>
                <Card className={classes.nestedCard}>
                    <Container size="small">
                        <CardContent className={classes.cardContent}>
                            <br/>
                            <div className={css({paddingTop: 40, paddingBottom: 40})}>
                                <LogoBox size={60} src={'/DRIVO_Logo.png'}/>
                            </div>
                            <form onSubmit={onSubmit}>
                                <H2>Please choose an installation</H2>

                                <Autocomplete
                                    options={installations}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(_e, selected) => setSelectedInstallation(selected || null)}
                                    renderOption={(option) => (
                                        <span style={{ fontSize: 20 }}>{option.name}</span>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Installations"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                style: {
                                                    height: 60,
                                                    fontSize: 22,
                                                    borderRadius: 6,
                                                },
                                            }}
                                        />
                                    )}
                                />
                                <div style={{ marginTop: 16 }} />
                                <Button type="submit"  disabled={!selectedInstallation}>Continue</Button>

                            </form>
                        </CardContent>
                    </Container>
                </Card>
            </Card>
        </StartContainer>
    )
}
